import { motion } from "framer-motion";
import { BUY_URL, X_URL } from "../constants";
import { XIcon } from "./XIcon";
import { CopyCA } from "./CopyCA";
import { SolanaLogo } from "./SolanaLogo";

export const Footer = () => (
  <footer className="relative z-10 border-t border-[#9945FF]/25 mt-10">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-20 text-center">
      <motion.h2
        initial={{ opacity: 0, scale: 0.92 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        data-testid="footer-headline"
        className="font-marker text-5xl sm:text-6xl lg:text-7xl gradient-sol text-glow-green -rotate-1"
      >
        DON'T FADE THE BULL
      </motion.h2>
      <p className="text-zinc-400 mt-5 max-w-xl mx-auto">
        He was right about $8. He'll tell you he's right about everything else too.
      </p>

      <div className="flex flex-wrap items-center justify-center gap-4 mt-9">
        <a
          href={BUY_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-buy-button"
          className="btn-buy font-bebas tracking-widest text-2xl rounded-full px-8 py-3"
        >
          BUY $CURB
        </a>
        <a
          href={X_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-x-button"
          className="btn-ghost-x rounded-full px-6 py-3 flex items-center gap-2 font-bebas tracking-widest text-xl"
        >
          <XIcon size={18} /> @CRYPTOCURB
        </a>
      </div>

      <div className="flex justify-center mt-7">
        <CopyCA testId="footer-copy-ca" compact />
      </div>

      <div className="flex items-center justify-center gap-3 mt-14 text-zinc-600">
        <SolanaLogo size={16} />
        <p className="text-xs max-w-lg" data-testid="footer-disclaimer">
          $CURB is a meme coin with no intrinsic value or expectation of financial return.
          It's a bull. On Solana. That's it. Do your own research — or don't, Curb already did.
        </p>
        <SolanaLogo size={16} />
      </div>
    </div>
  </footer>
);
